// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2k8gd","inputWrap":"Table_inputWrap__3j-d1","col":"Table_col__1Xu1H","bmiTooltip":"Table_bmiTooltip__1FrDg"};